import { render, staticRenderFns } from "./ObservationsSection.vue?vue&type=template&id=75d69b36&scoped=true&"
import script from "./ObservationsSection.vue?vue&type=script&lang=js&"
export * from "./ObservationsSection.vue?vue&type=script&lang=js&"
import style0 from "./ObservationsSection.vue?vue&type=style&index=0&id=75d69b36&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d69b36",
  null
  
)

export default component.exports